import type { SyntheticEvent } from "react";

import classNames from "classnames";
import useShouldMount from "hooks/useShouldMount";

import { useStyles } from "./styles";

const DEFAULT_UNMOUNT_DELAY = 1000 * 1.5;

export const Overlay: FC<OverlayProps> = ({
  children,
  className,
  forceMount = false,
  isOpen,
  onMouseDown,
  unmountDelay = DEFAULT_UNMOUNT_DELAY,
}) => {
  const [shouldMount, shouldOpen] = useShouldMount(isOpen, unmountDelay);
  const classes = useStyles();

  if (!forceMount && !shouldMount) return null;

  const overlayNode = (
    <div className={classNames(classes.overlay, !shouldOpen && "hide", className)} onMouseDown={onMouseDown}>
      <div className={classes.content}>{children}</div>
    </div>
  );

  return overlayNode;
};

type OverlayProps = {
  forceMount?: boolean;
  isOpen: boolean;
  onMouseDown?: (event: SyntheticEvent) => void;
  unmountDelay?: number;
};
